import * as Assets from "Data/Assets";
import * as HLF from "html-living-framework";
import * as Constants from "Data/Constants";
import { MusicGameLoopButton } from "GameObjects/MusicGame/Buttons/LoopButton";

export class MusicGameNoLoopButton extends MusicGameLoopButton {

    constructor(pData?: {}) {
        super({id: -1, ...pData});
    }

    /** @override */
    protected getBGSprite(pData: { id: number }) {
        return HLF.PixiUtils.makeSprite(Assets.MUS_BTN_MUTE, Assets.SPRITESHEET_MUSIC_GAME);
    }
}